import React from 'react';
import {
    ProductHistoryTable,
    Columns as HistoryColumns,
} from '@treez-ui/core/table/ProductHistoryTable';
import {ProductHistoryHookResult} from '~/lib/useProductHistory';
import {getProductHistory} from '~/utils/ProductAPI';
import TabPanel from './TabPanel';

interface Props {
    productId: number | undefined;
    catalogId: number | undefined;
    index: number;
    value: number;
}

export const CatalogHistory = (props: Props) => {
    const {index, value, productId, catalogId} = props;

    const historyColumns = Object.values(HistoryColumns).filter(
        (column) => column !== HistoryColumns.USERNAME
    );

    const [state, setState] = React.useState<ProductHistoryHookResult>({
        history: [],
        loading: false,
        error: undefined,
    });

    React.useEffect(() => {
        if (!catalogId || !productId || index !== value) {
            return;
        }
        if (state.history.length === 0) {
            setState({
                ...state,
                loading: true,
            });

            getProductHistory(productId, catalogId)
                .then((history) => {
                    // TODO: potentially to be removed with STZ-5422
                    const mappedHistory = history.map((entry) =>
                        entry.property === 'priceTierId'
                            ? {
                                  ...entry,
                                  description: undefined,
                              }
                            : entry
                    );
                    setState({
                        error: undefined,
                        history: mappedHistory,
                        loading: false,
                    });
                })
                .catch((error) => {
                    console.error(error);
                    setState({
                        error: String(error),
                        history: [],
                        loading: false,
                    });
                });
        }
    }, [catalogId, productId, index, value]);

    return (
        <TabPanel value={value} index={index}>
            <ProductHistoryTable
                fetching={state.loading}
                historyEntries={state.history}
                columns={historyColumns}
            />
        </TabPanel>
    );
};

export default CatalogHistory;
